import { gql } from '@apollo/client';

const REMOVE_UPCOMING_ACADEMIC_SESSION_SETTING = gql`
  mutation removeUpcomingAcademicSessionSetting($organizationId: Int!) {
    removeOrganizationSetting(
      where: { appId: null, organizationId: $organizationId, setting: "upcomingAcademicSession" }
    ) {
      setting
      value
    }
  }
`;

export default REMOVE_UPCOMING_ACADEMIC_SESSION_SETTING;
